import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../../components/InputComponent';
import * as generic from '../../../../components/Generico';
import { ProveedorPnService } from '../../../../service/trust/ProveedorPnService';
import { PersonaExpuesta } from '../../../../models/trust/proveedor/PersonaExpuesta';
import { BottomActionBar } from '../../../../components/ui/BottomActionBar';
import { useSubmitForm } from '../../../../hooks/useSubmitForm';

export const Declaracion = ({ toast, id, permss, proveedor, nuevoProveedor, siCliente, urls, setDialogProveedor, loadLazyData, setDialogAnexos, handlePrev, soloLectura }) => {
    const omodel = new PersonaExpuesta();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues, shouldTrim: true });
    const proveedorServicio = new ProveedorPnService();
    const { funcMessageBlobError, downloadPdf } = generic.Generico();
    const { inDrop, inText } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = useSubmitForm({
        toast, setError, onSuccess: (res) => {
            // Atrapamos la respuesta del backend y actualizamos el estado de la vista
            if (res?.data?.estado) {
                nuevoProveedor({ nemonico: res.data.estado }); // En el flujo solo se envia 'ENVIADO'
            }
        }
    });
    // Estados locales
    const [load, setLoad] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [anexosRequisitos, setAnexosRequisitos] = useState([]);
    // Estados para visibilidad condicional PEP
    const [esPep, setEsPep] = useState(false);
    const [esRelacionPep, setEsRelacionPep] = useState(false);

    useEffect(() => {
        editFicha();
    }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    const editFicha = () => {
        setIsLoading(true);
        proveedorServicio.consultarProveedor(id, { seccion: 'seccion4' }).then(res => {
            if (res.data.anexos_requisitos !== undefined) setAnexosRequisitos(res.data.anexos_requisitos);

            const _prov = res.data.proveedor;
            if (!_prov) { reset(defaultValues); return; }

            setEsPep(_prov.pep?.cat_id === true);
            setEsRelacionPep(_prov.relacion_pep?.cat_id === true);
            reset(generic.renewValues(_prov, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        data.id = id;
        data.seccion = 'seccion4';
        setLoad(true);
        proveedorServicio.editarProveedor(data).then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoad(false));
    }

    const onChangePep = (e) => {
        setEsPep(e.value?.cat_id === true);
    }

    const onChangeRelacionPep = (e) => {
        setEsRelacionPep(e.value?.cat_id === true);
    }

    const generarReporte = () => {
        setLoadReport(true);
        proveedorServicio.descargar(id).then(res => {
            downloadPdf(res, `${id}-Formulario-Informacion-Proveedor.pdf`);
        }).catch(error => {
            funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => { if (setDialogAnexos) setDialogAnexos(true); }

    const enviar = () => {
        enviarFormulario(id, 'ficha/trust/proveedor-pn/enviar', 'proveedorPn');
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores en la validación.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

                <Panel header={generic.renderPanelHeader('E', 'DECLARACIÓN DE PERSONA EXPUESTA POLÍTICAMENTE (PEP)', 'pi pi-id-card')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid p-2">
                        {inDrop('pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangePep, val: true }, 12)}
                        {esPep && inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                        {esPep && inText('tiempo_pep', { icon: 'pi pi-clock' }, 6)}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('', 'RELACIÓN CON PERSONA EXPUESTA POLÍTICAMENTE', 'pi pi-users')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid p-2">
                        {inDrop('relacion_pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangeRelacionPep, val: true }, 12)}
                        {esRelacionPep && inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                        {esRelacionPep && inText('cargo_nombre_pep', { icon: 'pi pi-briefcase' }, 6)}
                        {esRelacionPep && inText('tiempo_nombre_pep', { icon: 'pi pi-clock' }, 6)}
                        {esRelacionPep && inText('tipo_relacion_pep', { icon: 'pi pi-link' }, 6)}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('F', 'AUTORIZACIÓN DE ACCESO DE INFORMACIÓN', 'pi pi-file-edit')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Términos de Autorización</span>
                        </div>
                        {omodel.msgAcceso}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('G', 'DECLARACIÓN', 'pi pi-lock')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-shield text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Certificación de Veracidad y Reporte Fiscal</span>
                        </div>
                        {omodel.msgDeclaracion}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-shield text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                        </div>
                        {omodel.strAutorizacionTratamientoDatos}
                    </div>
                </Panel>

                {anexosRequisitos.length > 0 && (
                    <Panel header={generic.renderPanelHeader('', 'Anexos Requeridos', 'pi pi-paperclip')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                        <div className="p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-file text-yellow-600 text-lg"></i>
                                <span className="font-bold text-yellow-900">Documentos requeridos</span>
                            </div>
                            <ul className="pl-4 m-0">
                                {anexosRequisitos.map((req, index) => (
                                    <li key={index} className="mb-1">{req}</li>
                                ))}
                            </ul>
                        </div>
                    </Panel>
                )}

                <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onSave={true} onGenerate={() => generarReporte()} onSend={enviar}
                    onAttachments={subirReporte} loading={load || loadReport} isReadOnly={soloLectura} enableExtras={id != null} />
            </form>
        </>
    );
}
